(() => {
  if (!customElements.get('vivazz-coupon-price')) {
    class VivazzCouponPrice extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        try { this.variants = JSON.parse(this.querySelector('[data-vivazz-price-variants]').textContent); }
        catch { return; }
        this.form = document.getElementById(this.dataset.form);
        const update = (id) => {
          const variant = this.variants.find((item) => String(item.id) === String(id));
          if (!variant) return;
          this.querySelector('[data-vivazz-coupon-price]').textContent = variant.price;
          this.querySelector('[data-vivazz-installment]').textContent = variant.installment;
          const compare = this.querySelector('[data-vivazz-compare]');
          compare.textContent = variant.compare;
          compare.hidden = !variant.showCompare;
        };
        this.form?.addEventListener('variant:change', (event) => update(event.detail?.variant?.id), {signal: this.controller.signal});
        this.form?.addEventListener('change', (event) => {
          if (event.target.name === 'id') update(event.target.value);
        }, {signal: this.controller.signal});
        update(this.form?.elements.namedItem('id')?.value);
      }
      disconnectedCallback() { this.controller?.abort(); }
    }
    customElements.define('vivazz-coupon-price', VivazzCouponPrice);
  }
  const seen = new WeakSet();
  const start = (video) => {
    if (!video.dataset.vivazzLoaded) {
      video.querySelectorAll('source[data-vivazz-src]').forEach((source) => { source.src = source.dataset.vivazzSrc; });
      video.dataset.vivazzLoaded = 'true';
      video.load();
    }
    if (video.hasAttribute('data-vivazz-autoplay')) video.play().catch(() => {});
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver((entries) => {
    entries.forEach(({target, isIntersecting}) => {
      if (isIntersecting) start(target); else target.pause();
    });
  }, {rootMargin: '200px 0px'}) : null;
  const scan = (root) => root.querySelectorAll('video[data-vivazz-lazy-video]').forEach((video) => {
    if (seen.has(video)) return;
    seen.add(video);
    if (observer) observer.observe(video); else start(video);
  });
  scan(document);
  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();
